function checkURLParameters() {
  let e = new URLSearchParams(window.location.search);
  if (e.has("contact[tags]") && e.has("form_type")) {
    let t = e.get("contact[tags]"),
      i = e.get("form_type");
    if (t.includes("prospect") && t.includes("newsletter") && "customer" === i) {
      let s = document.querySelector(".custom-contant-already"),
        a = document.createTextNode("Ya est\xe1s suscrito con este correo electr\xf3nico.");
      if (s) {
        s.appendChild(a);
      }
    }
  }
}
if (typeof jQuery !== "undefined") {
  jQuery(document).ready(function ($) {
      if (window.location.hash === '#judgeme_product_reviews') {
    setTimeout(function () {
      const reviews = document.querySelector('#judgeme_product_reviews');

      if (reviews) {
        reviews.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 1000);
  }
  
    if (typeof $.fn.slick !== "undefined") {
      jQuery(".mobile-view").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="slick-next">Next</button>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
    $("#scroll-button").on("click", function (event) {
      event.preventDefault(); // Prevent the default action of the link

      // Get the target element by its ID
      var targetElement = $("#shopify-section-template--23386512261459__main");

      // Check if the target element exists before scrolling
      if (targetElement.length) {
        // Scroll to the target element with smooth animation
        $("html, body").animate(
          {
            scrollTop: targetElement.offset().top,
          },
          1000,
        ); // 1000ms for smooth scrolling duration
      } else {
        console.error("Target element not found.");
      }
    });

    $(".dynamic-sections .image-with-text__wrapper .buttons a.custm-spin-cls").on("click", function () {
      $("#wheelify-spin-trigger-cc").trigger("click");
    });

    window.addEventListener("load", checkURLParameters);

    $(".accordion-containercustom .accordiancstmset a").click(function (e) {
      (e.preventDefault(),
        $(this).hasClass("active")
          ? $(this).removeClass("active")
          : ($(".accordion-containercustom .accordiancstmset a").removeClass("active"), $(this).addClass("active")));
    });

    var $first = $(".accordion-containercustom .accordiancstmset").first();
    $first.find(".custom-section").addClass("active");
    $first.find(".custom-quest-answ-flx").slideDown();

    // Step 2: On accordion click
    $(".accordion-containercustom").on("click", ".custom-section", function (e) {
      e.preventDefault();

      var $this = $(this);
      var $content = $this.next(".custom-quest-answ-flx");

      // Ignore click if already active
      if ($this.hasClass("active")) {
        return;
      }

      // Close all other accordions
      $(".custom-section").removeClass("active");
      $(".custom-quest-answ-flx").stop(true, true).slideUp();

      // Open the clicked one
      $this.addClass("active");
      $content.stop(true, true).slideDown();
    });
    if (typeof $.fn.slick !== "undefined") {
      $(".owl-carousel.owl-theme").slick({
        dots: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: !0,
              dots: !0,
            },
          },
          {breakpoint: 867, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 767, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 480, settings: {slidesToShow: 1, slidesToScroll: 1}},
        ],
      });
    }
    const videos = document.querySelectorAll(".custom-video"),
      playButtons = document.querySelectorAll(".cstm-requirment");
    playButtons.forEach((e, t) => {
      e.addEventListener("click", () => {
        let i = videos[t];
        i.paused ? (i.play(), (e.style.opacity = 0)) : (i.pause(), (e.style.opacity = 1));
      });
    });

    $(document).ready(function () {
      var currentUrl = window.location.href;

      $(".main-order-custom").each(function () {
        var parentLink = $(this).closest("a").attr("href");

        if (parentLink && currentUrl.indexOf(parentLink) !== -1 && parentLink !== "/") {
          $(".main-order-custom").removeClass("active");
          $(this).addClass("active");
        }
      });

      $(".main-order-custom").click(function () {
        var index = $(".main-order-custom").index(this);
        $(".main-order-custom").removeClass("active");
        $(this).addClass("active");
        localStorage.setItem("activeElementIndex", index);
      });

      if ($(".main-order-custom.active").length === 0) {
        var storedIndex = localStorage.getItem("activeElementIndex");
        if (storedIndex !== null) {
          $(".main-order-custom").eq(storedIndex).addClass("active");
        }
      }
    });

    $(".product-details-varient").click(function () {
      var e = $(this).attr("id");
      ($(".product-details-varient").removeClass("active"), $(this).addClass("active"), console.log("Clicked variant ID: " + e));
    });

    $(".product-details-varient").click(function () {
      var e = $(this).attr("id"),
        t = $("#buy-now-link"),
        i = t.attr("href").replace(/\/\d+:/, "/" + e + ":");
      (t.attr("href", i), console.log("Updated buy now link with variant ID: " + i));
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var currentUrl = window.location.pathname; // Use pathname to match the relative URL
  let colorAnchors = document.querySelectorAll(".color_anchor");

  colorAnchors.forEach((anchor) => {
    let anchorUrl = anchor.getAttribute("href"); // Use href attribute for comparison

    if (currentUrl === anchorUrl) {
      // Exact match of the pathname
      anchor.classList.add("active");
    } else {
      anchor.classList.remove("active");
    }
  });
});

let e = document.querySelectorAll("img");
e.forEach((e) => {
  e.setAttribute("loading", "lazy");
});

// Helper function to set a cookie for ACT user
function setActCookie(name, value, minutes) {
  const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

// Helper function to get a cookie by name
function getActCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

/*
// Check if 'isACTUser' cookie is already set
document.addEventListener("DOMContentLoaded", function () {
  // If not set, and URL contains 'atc=true', then set the cookie
  if (window.location.pathname.endsWith("/pages/6-beneficios-2-efecto")) {
    setActCookie('isACTUser', 'true', 4320);
    console.log("sssss");
    document.body.classList.add("atc-user-activate");
  }

  const isACTUserCookie = getActCookie('isACTUser');
  const body = document.body;
  if (isACTUserCookie == 'true') {
    if (!body.classList.contains("atc-user-activate")) {
      body.classList.add("atc-user-activate");
    }
  } else {
    if (body.classList.contains("atc-user-activate")) {
      body.classList.remove("atc-user-activate");
    }
  }
});*/

// Robust ATC Cookie Setter for /pages/6-beneficios-2-efecto
(function () {
  const EXPIRY_MINUTES = 14400; // 10 days in minutes
  const EXPIRY_MS = EXPIRY_MINUTES * 60 * 1000;

  function setActCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
  }

  function getActCookie(name) {
    const nameEQ = name + "=";
    const parts = document.cookie.split(";");
    for (let c of parts) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  const allowedEnds = ["/pages/6-beneficios-2-efecto", "/pages/8-benefits", "/pages/frizz", "/products/kertox-efecto-botox-capilar-instantaneo", "/pages/articulo-pelo-silencioso"];

  if (!allowedEnds.some((end) => window.location.pathname.endsWith(end))) return;

  function applyATCActivation() {
    const now = Date.now();

    let lsValue = localStorage.getItem("isACTUser");
    let lsTime = localStorage.getItem("isACTUser_time");
    let cookieValue = getActCookie("isACTUser");

    // Check expiry for localStorage
    if (lsValue === "true" && lsTime) {
      const age = now - Number(lsTime);
      if (age > EXPIRY_MS) {
        // EXPIRED → clear LS + cookie
        localStorage.removeItem("isACTUser");
        localStorage.removeItem("isACTUser_time");
        document.cookie = "isACTUser=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
        lsValue = null;
        cookieValue = null;
        console.log("⛔ Expired — cleared ACT");
      }
    }

    // If triggered or first time
    if (window.location.search.includes("atc=true") || !lsValue || !cookieValue) {
      localStorage.setItem("isACTUser", "true");
      localStorage.setItem("isACTUser_time", now.toString());

      setActCookie("isACTUser", "true", EXPIRY_MINUTES);

      console.log("🔥 Set ACT (LS + Cookie) with timestamp");
      lsValue = "true";
    }

    // Apply class
    if (lsValue === "true") {
      document.body.classList.add("atc-user-activate");
    } else {
      document.body.classList.remove("atc-user-activate");
    }
  }

  applyATCActivation();

  const interval = setInterval(applyATCActivation, 2000);
  setTimeout(() => clearInterval(interval), 30000);

  document.addEventListener("DOMContentLoaded", applyATCActivation);
})();

// Helper function to get a cookie by name
function getActCookiess(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// Check if 'isACTUser' cookie is already set
document.addEventListener("DOMContentLoaded", function () {
  const now = Date.now();

  const isACTUserCookie = getActCookiess("isACTUser");
  const body = document.body;
  if (isACTUserCookie == "true") {
    if (!body.classList.contains("atc-user-activate")) {
      body.classList.add("atc-user-activate");
    }
  } else {
    if (body.classList.contains("atc-user-activate")) {
      body.classList.remove("atc-user-activate");
    }

    let lsValue = localStorage.getItem("isACTUser");
    let lsTime = localStorage.getItem("isACTUser_time");

    let EXPIRY_MINUTES = 14400; // 10 days in minutes
    let EXPIRY_MS = EXPIRY_MINUTES * 60 * 1000;
    // Check expiry for localStorage
    if (lsValue === "true" && lsTime) {
      const age = now - Number(lsTime);
      if (age > EXPIRY_MS) {
        // EXPIRED → clear LS + cookie
        localStorage.removeItem("isACTUser");
        localStorage.removeItem("isACTUser_time");
      } else {
        body.classList.add("atc-user-activate");
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('.custom_bundle .swatch__option input[type="radio"]');

  function applyLogic(value) {
    const customBundleForm = document.querySelector(".custom_bandle_form");
    const rechargeWidget = document.querySelector(".new-form-atc");
    const mainButtonBox = document.querySelector(".main_button_box");

    if (!customBundleForm || !rechargeWidget || !mainButtonBox || !radios.length) return;

    const isKertox = value === "1 x Kertox 30ml";

    customBundleForm.style.display = isKertox ? "block" : "none";
    rechargeWidget.style.display = isKertox ? "none" : "block";
    mainButtonBox.style.display = isKertox ? "none" : "flex";

    console.log("rechargeWidget", isKertox ? "none" : "block");

    if (isKertox) {
      console.log("Selected: 1 KERTOX 30ML");
    }
  }

  // ✅ Normal instant logic on change (NO retry here)
  radios.forEach((radio) => {
    radio.addEventListener("change", function () {
      applyLogic(this.value);
    });
  });

  // ✅ Retry logic ONLY for page load
  const checkedRadio = document.querySelector('.custom_bundle .swatch__option input[type="radio"]:checked');

  if (checkedRadio) {
    let retryCount = 0;
    const maxRetries = 10;
    const retryInterval = 1000; // total 2000ms

    const retryApplyOnLoad = () => {
      const rechargeWidget = document.querySelector(".new-form-atc");

      if (rechargeWidget || retryCount >= maxRetries) {
        applyLogic(checkedRadio.value);
        if (!rechargeWidget) {
          console.warn("Recharge widget not found after 10 tries. Applied logic anyway.");
        }
        return;
      }

      retryCount++;
      setTimeout(retryApplyOnLoad, retryInterval);
    };

    retryApplyOnLoad();
  }
});

function initNewFormUI(retries = 10) {
  const newForm = document.querySelector("#new-form");
  const cofre_kertox = document.querySelector(".cofre_kertox");
  console.log("retries", retries);
  console.log("newForm", newForm);
  if (!cofre_kertox) return;
  // Retry if #new-form not found yet
  if (!newForm) {
    if (retries > 0) {
      setTimeout(() => initNewFormUI(retries - 1), 1000);
    }
    return;
  }

  // ---- Once #new-form is available ----

  // Create cafre-box container
  const cafreBox = document.createElement("div");
  cafreBox.classList.add("cafre-box");
  newForm.prepend(cafreBox);

  // Function to update content inside cafre-box
  function updateCafreBox(optionElement) {
    cafreBox.innerHTML = optionElement.outerHTML;
  }

  // Select default selected item
  const defaultSelected = newForm.querySelector(".new-form-option.selectedWB");
  if (defaultSelected) updateCafreBox(defaultSelected);

  // Add click events to options
  const allOptions = newForm.querySelectorAll(".new-form-option");
  allOptions.forEach((option) => {
    option.addEventListener("click", function () {
      allOptions.forEach((o) => o.classList.remove("selectedWB"));
      this.classList.add("selectedWB");
      updateCafreBox(this);
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  // Start the retry process
  console.log("initNewFormUI");
  initNewFormUI();
});

document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname.endsWith("/new-mystery-box-atc") ||
    window.location.pathname.endsWith("/kertox-advertorial-6-beneficios-glow-touch") ||
    window.location.pathname.endsWith("/products/oferta-kertox-glow-touch") ||
    window.location.pathname.endsWith("/kertox-botox-capilar-instantaneo-mysterybox")
  ) {
    document.body.classList.add("atc-user-activatev2");
  }

  if (window.Shopify?.routes?.root === "/es-mx/") {
    const EUR_TO_MXN = 20.43; // 🔁 Static conversion rate

    // Regex to match all your formats
    const priceRegex = /(\d+(?:[.,]\d+)?)\s*€?\s*\/\s*ml|\d+(?:[.,]\d+)?€\/ml/gi;

    function convertText(node) {
      node.nodeValue = node.nodeValue.replace(priceRegex, function (match) {
        // Extract number (handles comma & dot)
        let value = match.match(/\d+(?:[.,]\d+)?/)[0];
        value = parseFloat(value.replace(",", "."));

        if (isNaN(value)) return match;

        const converted = (value * EUR_TO_MXN).toFixed(2);

        return `${converted} $ / ml`;
      });
    }

    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        convertText(node);
      } else {
        node.childNodes.forEach(walk);
      }
    }

    setTimeout(function () {
      walk(document.body);
    }, 4000);
  }



  
});

(function() {
    // Inject minimal spinner styles once
    if (!document.getElementById('featured-btn-loader-style')) {
        var style = document.createElement('style');
        style.id = 'featured-btn-loader-style';
        style.textContent = `
            .fetaured-btn.is-loading,
            .featured-btn.is-loading {
                pointer-events: none;
                position: relative;
                color: transparent !important;
            }
            .fetaured-btn.is-loading::after,
            .featured-btn.is-loading::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 20px;
                height: 20px;
                margin: -10px 0 0 -10px;
                border: 2px solid rgba(255, 255, 255, 0.35);
                border-top-color: #ffffff;
                border-radius: 50%;
                animation: featured-btn-spin 0.6s linear infinite;
            }
            @keyframes featured-btn-spin {
                to { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
    }

    var checkExist = setInterval(function() {
        if (window.location.pathname.includes('6-beneficios-2-efecto')) {

            var buttons = document.querySelectorAll('.fetaured-btn, .featured-btn');

            if (buttons.length > 0) {
                buttons.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        if (btn.classList.contains('is-loading')) return;

                        btn.classList.add('is-loading');

                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: 49466263077203, quantity: 1 })
                        })
                        .then(res => res.json())
                        .then(data => {
                            if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
                                window.PXUTheme.jsAjaxCart.updateGiftProducts().then(() => {
                                    window.PXUTheme.jsAjaxCart.updateView();
                                    setTimeout(() => {
                                        window.PXUTheme.jsAjaxCart.showDrawer();
                                        btn.classList.remove('is-loading');
                                    }, 400);
                                });
                            } else {
                                window.location.href = '/cart';
                            }
                        })
                        .catch(() => {
                            btn.classList.remove('is-loading');
                        });
                    });
                });

                clearInterval(checkExist);
            }
        } else {
            clearInterval(checkExist);
        }
    }, 100);
})();

/* =====================================================================
   OPT007 — Sticky add to cart (mobile only, /pages/6-beneficios-2-efecto)
   Takes over the existing .sticky-add-to-cart-btn:
   - adds variant 49466263077203 (x1) + free gift, same chain as .featured-btn
   - added state: "✓ Añadido" grey + disabled, cart icon with count, name not underlined
   - reverts when the item leaves the cart; correct state on load / back
   ===================================================================== */
(function () {
  if (!window.location.pathname.includes("6-beneficios-2-efecto")) return;

  var VARIANT_ID = 49466263077203;
  var BTN = ".sticky-add-to-cart-btn";
  var NAME_SELECTOR = null;           // optional: the bar's product-name selector; null = auto-detect
  var OFFER_SELECTOR = "#new-form";   // where the name scrolls to in the default state
  var ADDED_TEXT = "Añadido";
  var mq = window.matchMedia("(max-width: 798px)");
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var state = "default";              // default | loading | added
  var count = 0;
  var busy = false;

  /* styles: see OPT007 block in styles.css.liquid */

  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CART = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M26.93 6.06001C26.6482 5.7276 26.2973 5.46058 25.9019 5.27752C25.5064 5.09446 25.0758 4.99976 24.64 5H6.72L6.28 2.48C6.15756 1.78429 5.79354 1.1541 5.25207 0.700439C4.7106 0.246772 4.0264 -0.00126888 3.32 4.8815e-06H1C0.734784 4.8815e-06 0.48043 0.105362 0.292893 0.292898C0.105357 0.480434 0 0.734788 0 1C0 1.26522 0.105357 1.51958 0.292893 1.70711C0.48043 1.89465 0.734784 2 1 2H3.32C3.55823 1.99654 3.78987 2.07825 3.97321 2.23042C4.15654 2.38259 4.27952 2.59521 4.32 2.83L6.72 16.52C6.84356 17.2226 7.21342 17.8581 7.76321 18.3126C8.313 18.7671 9.00675 19.0108 9.72 19H23.31C24.0276 19.0096 24.7249 18.7617 25.2753 18.3012C25.8257 17.8406 26.1928 17.1981 26.31 16.49L27.65 8.49C27.7146 8.05696 27.6836 7.61503 27.5592 7.19524C27.4348 6.77545 27.2201 6.38797 26.93 6.06001ZM24.29 16.16C24.2517 16.3966 24.1296 16.6116 23.9461 16.7658C23.7625 16.92 23.5297 17.0031 23.29 17H9.68C9.44177 17.0035 9.21013 16.9218 9.02679 16.7696C8.84346 16.6174 8.72048 16.4048 8.68 16.17L7.07 7H24.64C24.7859 6.99812 24.9305 7.02821 25.0636 7.08815C25.1967 7.14809 25.315 7.23644 25.4103 7.34698C25.5056 7.45753 25.5755 7.58759 25.6152 7.72805C25.6549 7.8685 25.6634 8.01594 25.64 8.16L24.29 16.16ZM21.5 21C20.8078 21 20.1311 21.2053 19.5555 21.5899C18.9799 21.9744 18.5313 22.5211 18.2664 23.1606C18.0015 23.8002 17.9322 24.5039 18.0673 25.1828C18.2023 25.8618 18.5356 26.4854 19.0251 26.9749C19.5146 27.4644 20.1383 27.7977 20.8172 27.9328C21.4961 28.0678 22.1999 27.9985 22.8394 27.7336C23.4789 27.4687 24.0256 27.0201 24.4101 26.4445C24.7947 25.8689 25 25.1922 25 24.5C25 23.5717 24.6313 22.6815 23.9749 22.0251C23.3185 21.3688 22.4283 21 21.5 21ZM21.5 26C21.2033 26 20.9133 25.912 20.6666 25.7472C20.42 25.5824 20.2277 25.3481 20.1142 25.074C20.0007 24.7999 19.9709 24.4983 20.0288 24.2074C20.0867 23.9164 20.2296 23.6491 20.4393 23.4393C20.6491 23.2296 20.9164 23.0867 21.2074 23.0288C21.4983 22.9709 21.7999 23.0007 22.074 23.1142C22.3481 23.2277 22.5824 23.42 22.7472 23.6667C22.912 23.9133 23 24.2033 23 24.5C23 24.8978 22.842 25.2794 22.5607 25.5607C22.2794 25.842 21.8978 26 21.5 26ZM11.5 21C10.8078 21 10.1311 21.2053 9.5555 21.5899C8.97993 21.9744 8.53133 22.5211 8.26642 23.1606C8.00151 23.8002 7.9322 24.5039 8.06725 25.1828C8.2023 25.8618 8.53564 26.4854 9.02513 26.9749C9.51461 27.4644 10.1383 27.7977 10.8172 27.9328C11.4961 28.0678 12.1999 27.9985 12.8394 27.7336C13.4789 27.4687 14.0256 27.0201 14.4101 26.4445C14.7947 25.8689 15 25.1922 15 24.5C15 23.5717 14.6313 22.6815 13.9749 22.0251C13.3185 21.3688 12.4283 21 11.5 21ZM11.5 26C11.2033 26 10.9133 25.912 10.6666 25.7472C10.42 25.5824 10.2277 25.3481 10.1142 25.074C10.0006 24.7999 9.97094 24.4983 10.0288 24.2074C10.0867 23.9164 10.2296 23.6491 10.4393 23.4393C10.6491 23.2296 10.9164 23.0867 11.2074 23.0288C11.4983 22.9709 11.7999 23.0007 12.074 23.1142C12.3481 23.2277 12.5824 23.42 12.7472 23.6667C12.912 23.9133 13 24.2033 13 24.5C13 24.8978 12.842 25.2794 12.5607 25.5607C12.2794 25.842 11.8978 26 11.5 26Z" fill="currentColor"/></svg>';

  /* ---------- helpers ---------- */
  function isOurLine(item) {
    var p = item.properties || {};
    if (p.Rewards === "Free Gift" || p._gift === "true" || p._upsell === "1") return false;
    return Number(item.variant_id) === VARIANT_ID;
  }

  function getCart() {
    return fetch(root + "cart.js", { cache: "no-store", credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  // The bar = closest fixed-position ancestor of the button
  function barOf(btn) {
    var el = btn.parentElement;
    while (el && el !== document.body) {
      if (getComputedStyle(el).position === "fixed") return el;
      el = el.parentElement;
    }
    return btn.parentElement;
  }

  // Product name inside the bar (configured selector, or first text element mentioning Kertox)
  function nameOf(bar, btn) {
    if (NAME_SELECTOR) return bar.querySelector(NAME_SELECTOR);
    var els = bar.querySelectorAll("*");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.contains(btn) || btn.contains(el)) continue;
      if (!/kertox/i.test(el.textContent || "")) continue;
      // deepest element holding the name (no child also holding it)
      var deeper = false;
      for (var j = 0; j < el.children.length; j++) if (/kertox/i.test(el.children[j].textContent || "")) deeper = true;
      if (!deeper) return el;
    }
    return null;
  }

  /* ---------- render ---------- */
  function render() {
    if (!mq.matches) return;
    document.querySelectorAll(BTN).forEach(function (btn) {
      if (!btn.hasAttribute("data-opt007-original")) btn.setAttribute("data-opt007-original", btn.innerHTML);
      var bar = barOf(btn);

      // button
      btn.classList.toggle("opt007-loading", state === "loading");
      btn.classList.toggle("opt007-added", state === "added");
      var wantAdded = state === "added";
      if (wantAdded && !btn.querySelector("[data-opt007-added]")) {
        btn.innerHTML = '<span data-opt007-added>' + CHECK + ADDED_TEXT + "</span>";
      } else if (!wantAdded && btn.querySelector("[data-opt007-added]")) {
        btn.innerHTML = btn.getAttribute("data-opt007-original");
      }
      if (state === "default") { btn.removeAttribute("disabled"); btn.setAttribute("aria-disabled", "false"); }
      else { btn.setAttribute("disabled", "disabled"); btn.setAttribute("aria-disabled", "true"); }

      // own wrapper around the button + cart icon: <div class="opt007-actions">
      var wrap = btn.parentElement;
      if (!wrap.classList.contains("opt007-actions")) {
        wrap = document.createElement("div");
        wrap.className = "opt007-actions";
        btn.insertAdjacentElement("beforebegin", wrap);
        wrap.appendChild(btn);
      }
      wrap.classList.toggle("opt007-actions--added", wantAdded);

      var cartBtn = wrap.querySelector(".opt007-cart-btn");
      if (wantAdded) {
        if (!cartBtn) {
          cartBtn = document.createElement("button");
          cartBtn.type = "button";
          cartBtn.className = "opt007-cart-btn";
          cartBtn.setAttribute("aria-label", "Ver cesta");
          cartBtn.innerHTML = CART + "<span data-opt007-count></span>";
          wrap.appendChild(cartBtn);
        }
        cartBtn.querySelector("[data-opt007-count]").textContent = count;
      } else if (cartBtn) {
        cartBtn.remove();
      }

      // product name
      var name = nameOf(bar, btn);
      if (name) {
        name.classList.add("opt007-name");
        name.classList.toggle("opt007-name--added", wantAdded);
      }
    });
  }

  function setState(s) { state = s; render(); }

  var seq = 0;
  function refresh() {
    var mine = ++seq;
    return getCart().then(function (cart) {
      if (mine !== seq || busy) return;
      count = cart.item_count;
      setState(cart.items.some(isOurLine) ? "added" : "default");
    }).catch(function () {});
  }
  var timer;
  function scheduleRefresh(ms) { clearTimeout(timer); timer = setTimeout(refresh, ms || 400); }

  /* ---------- clicks (capture phase, so the app's own handler never runs on mobile) ---------- */
  window.addEventListener("click", function (e) {
    if (!mq.matches) return;

    if (e.target.closest(".opt007-cart-btn")) {
      e.preventDefault(); e.stopPropagation();
      var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart;
      if (ac && ac.showDrawer) ac.showDrawer(); else window.location.href = root + "cart";
      return;
    }

    var name = e.target.closest(".opt007-name");
    if (name && !name.classList.contains("opt007-name--added")) {
      e.preventDefault(); e.stopPropagation();
      var offer = document.querySelector(OFFER_SELECTOR);
      if (offer) offer.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    var btn = e.target.closest(BTN);
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (busy || state !== "default") return;     // disabled + double-tap guard

    busy = true;
    setState("loading");
    getCart()
      .then(function (cart) {
        if (cart.items.some(isOurLine)) return;  // never a second unit
        return fetch(root + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
        }).then(function (r) { if (!r.ok) throw new Error("cart/add " + r.status); });
      })
      .then(function () {
        var ac = window.PXUTheme && window.PXUTheme.jsAjaxCart;
        if (!ac) return;
        return Promise.resolve(ac.updateGiftProducts && ac.updateGiftProducts()).then(function () {
          if (ac.updateView) ac.updateView();
        });
      })
      .catch(function (err) { console.error("[OPT007]", err); })
      .then(function () { busy = false; return refresh(); });
  }, true);

  /* ---------- keep in sync with the real cart ---------- */
  // any cart write on the page (drawer remove, qty, gift logic, other buttons)
  if (window.fetch && !window.fetch._opt007) {
    var nativeFetch = window.fetch;
    var wrapped = function (input) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { scheduleRefresh(); }, function () { scheduleRefresh(); });
      return p;
    };
    wrapped._opt007 = true;
    window.fetch = wrapped;
  }
  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (ev, xhr, s) {
      if (s && /\/cart\/(add|change|update|clear)/.test(s.url || "")) scheduleRefresh();
    });
  }
  // drawer opened / closed
  new MutationObserver(function () { scheduleRefresh(150); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  // the app re-renders its bar (e.g. offer change): re-apply our state
  var raf;
  new MutationObserver(function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var b = document.querySelector(BTN);
      if (b && (!b.hasAttribute("data-opt007-original") ||
          (state === "added" && !b.querySelector("[data-opt007-added]")))) render();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  // reload, back/forward, tab focus, rotation
  window.addEventListener("pageshow", function () { scheduleRefresh(50); });
  document.addEventListener("visibilitychange", function () { if (!document.hidden) scheduleRefresh(50); });
  mq.addEventListener && mq.addEventListener("change", function () { scheduleRefresh(50); });

  refresh();
})();